import { render, staticRenderFns } from "./StepInfoFooter.vue?vue&type=template&id=64521394&scoped=true"
import script from "./StepInfoFooter.vue?vue&type=script&lang=js"
export * from "./StepInfoFooter.vue?vue&type=script&lang=js"
import style0 from "./StepInfoFooter.vue?vue&type=style&index=0&id=64521394&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64521394",
  null
  
)

export default component.exports